module.exports = require("react-dom");


//////////////////
// WEBPACK FOOTER
// external {"commonjs":"react-dom","commonjs2":"react-dom","amd":"ReactDOM","root":"ReactDOM"}
// module id = 10
// module chunks = 0